/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class DateRangeDirectiveController {
        public static $inject: string[] = [
            '$dealerwareInternationalizationDateFormats',
            '$dealerwareNotification',
            '$mdDateLocale',
            '$dealerwareInternationalizationData'
        ];

        public configuring: boolean = false;
        public type: string;
        public times: number;
        public interval: string;
        public startDate: Date;
        public endDate: Date;
        public showNextChoice: boolean;
        public onCancel: any;
        public onClear: any;
        public onApply: any;
        public checkIsCancelDisabled: any;
        public checkIsClearDisabled : any;
        public checkIsApplyDisabled : any;
        public locale: any;
        public id: string;
        public labels: {};

        constructor(public $dealerwareInternationalizationDateFormats: any,
            public $dealerwareNotification: any,
            public $mdDateLocale: any,
            public $dealerwareInternationalizationData: any
        ) {
            this.getLabels('dashboard');
            this.setInitLocale();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
            .getLabels()
            .then( function(res) {
                _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public setInitLocale(): void {
            const lang = this.getCurrentLanguage();
            if( lang === 'fr') {
                const that = this;
                this.$dealerwareInternationalizationDateFormats
                .getLocales()
                .then(function(res){
                    that.setFormatLocale(res.data[lang], lang)
                },
                { function(err){console.log("A problem occurred during setting locale", err)}
                });
            }
        }

        private setFormatLocale(locale, lang){
            const that = this;

            this.startDate = null;
            this.endDate = null;

            this.$mdDateLocale.parseDate = function(dateString) {
              var m = moment(dateString, 'L', true);
              return m.isValid() ? m.toDate() : new Date(NaN);
            };
            
            this.$mdDateLocale.formatDate = function(date) {
              var m = moment(date);
              return m.isValid() ? m.format(that.$dealerwareInternationalizationDateFormats.formats[lang]) : '';
            };
             
            this.$mdDateLocale.months = locale.DATETIME_FORMATS.MONTH;
            this.$mdDateLocale.shortMonths = locale.DATETIME_FORMATS.SHORTMONTH;
            this.$mdDateLocale.shortDays = locale.DATETIME_FORMATS.SHORTDAY;
            this.$mdDateLocale.days = locale.DATETIME_FORMATS.DAY;
        }

        public getCurrentLanguage() {
            const lng = localStorage.getItem('language');
            return (lng === 'fr' || lng === 'fr-CA') ? 'fr' : lng;
        }

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }

        public clear() : void {
            if (this.onClear && angular.isFunction(this.onClear)) {
                this.onClear();
            }
        }

        public apply() : void {
            if (this.onApply && angular.isFunction(this.onApply)) {
                this.onApply();
            }
        }

        public isCancelDisabled () : boolean {

            if (this.checkIsCancelDisabled && angular.isFunction(this.checkIsCancelDisabled)) {
                return this.checkIsCancelDisabled();
            }

            return false;
        }

        public isClearDisabled () : boolean {

            if (this.checkIsClearDisabled && angular.isFunction(this.checkIsClearDisabled)) {
                return this.checkIsClearDisabled();
            }

            return false;
        }

        public isApplyDisabled () : boolean {

            if (this.checkIsApplyDisabled && angular.isFunction(this.checkIsApplyDisabled)) {
                return this.checkIsApplyDisabled();
            }

            return false;
        }
    }

    getDealerwareWebComponentsModule().controller('DateRangeDirectiveController', DateRangeDirectiveController);

    export class DateRangeDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'DateRangeDirectiveController';
        public controllerAs     : string    =   'dateRangeController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            type: '=',
            times: '=',
            interval: '=',
            startDate: '=',
            endDate: '=',
            showNextChoice: '=?',
            onCancel: '&',
            onClear: '&?',
            onApply: '&',
            checkIsCancelDisabled: '&?',
            checkIsClearDisabled: '&?',
            checkIsApplyDisabled: '&?',
            id: '@'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/date_range/date_range_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("dealerwareDateRange",() => new DateRangeDirective());
 }
